// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.auto-logout-page .settings-modal-header {
  position: relative;
  justify-content: center;
}

.auto-logout-page .back-button {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.auto-logout-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.auto-logout-content {
  padding: 0 24px;
  flex-grow: 1;
  overflow-y: auto;
}

.auto-logout-form {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.auto-logout-form .form-group {
  margin-top: 24px;
}

.auto-logout-footer {
  margin-top: auto;
  padding-bottom: 24px;
  display: flex;
  justify-content: flex-end;
}

.auto-logout-footer .settings-modal-button.primary {
  background-color: var(--netsfere-red);
}
.auto-logout-footer .settings-modal-button.primary:hover {
  background-color: rgb(195, 60, 75);
}

.auto-logout-footer .settings-modal-button {
  min-width: 120px;
}`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/AutoLogoutPage.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["\n.auto-logout-page .settings-modal-header {\n  position: relative;\n  justify-content: center;\n}\n\n.auto-logout-page .back-button {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.auto-logout-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n.auto-logout-content {\n  padding: 0 24px;\n  flex-grow: 1;\n  overflow-y: auto;\n}\n\n.auto-logout-form {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.auto-logout-form .form-group {\n  margin-top: 24px;\n}\n\n.auto-logout-footer {\n  margin-top: auto;\n  padding-bottom: 24px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.auto-logout-footer .settings-modal-button.primary {\n  background-color: var(--netsfere-red);\n}\n.auto-logout-footer .settings-modal-button.primary:hover {\n  background-color: rgb(195, 60, 75);\n}\n\n.auto-logout-footer .settings-modal-button {\n  min-width: 120px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
